// extracted by mini-css-extract-plugin
module.exports = {"block":"PredictionStatus_block__oRKlU","prediction":"PredictionStatus_prediction__meHHk","rpmText":"PredictionStatus_rpmText__qV__q"};